import { useCallback, useEffect } from 'react'
import { useMutation } from '@apollo/client'
import { setAlertQueue } from 'cache/alerts'
import { INTERNAL_DEAL_STATUS, setDealStatus } from 'cache/deal-status'
import { MessageType } from 'ts/enums/messageType.enums'
import LOCK_DEAL_MUTATION, { LockUnlockDealResponse } from '../queries/mutations/deal-lock'
import { useUserProfile } from './use-user-profile'

export const useLockDeal = () => {
  const { userId } = useUserProfile()
  const [lockDealMutation, { data, loading, error }] = useMutation<LockUnlockDealResponse>(
    LOCK_DEAL_MUTATION,
    {
      fetchPolicy: 'no-cache',
    }
  )

  const handleLockDeal = useCallback(
    async (dealId: number) => {
      try {
        await lockDealMutation({
          variables: {
            bdId: dealId,
            userId,
            lockFlag: true,
            bdIds: [dealId],
          },
        })
      } catch (error) {
        setAlertQueue({
          type: MessageType.ERROR,
          message: 'Failed to lock deal. Please try again.',
        })
        return { error }
      }
    },
    [lockDealMutation, userId]
  )

  useEffect(() => {
    if (data?.lockUnlockDeal.isSuccess) {
      setDealStatus(INTERNAL_DEAL_STATUS.LOCKED)
    }
  }, [data?.lockUnlockDeal.isSuccess])

  return {
    lockDealMutation: handleLockDeal,
    isSuccessfull: data?.lockUnlockDeal.isSuccess,
    isLoading: loading,
    error,
  }
}
